import React from 'react'
import styles from './HeaderNotification.module.scss'

interface OwnProps {
  onClick: () => void
  className: string
  value?: number
  displayValue?: boolean
}

const HeaderNotification = ({ onClick, className, displayValue, value }: OwnProps) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault()
    onClick()
  }

  return (
    <a className={`${styles.header__notification} ${className}`} onClick={handleClick} href="#">
      {displayValue && <span className={`${styles.header__notification_text}`}>{value}</span>}
    </a>
  )
}

export default HeaderNotification
